import { render, staticRenderFns } from "./custom-navbar.component.vue?vue&type=template&id=25b55a96&"
import script from "./custom-navbar.component.ts?vue&type=script&lang=ts&"
export * from "./custom-navbar.component.ts?vue&type=script&lang=ts&"
import style0 from "./custom-navbar.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports